// test2487
(2487 && 0);
